import Endpoint from './endpoint'
import { API_URL } from './index'

export default class SubstitutionTags extends Endpoint {
  async all() {
    let url = new URL('/api/substitution_tags', API_URL)

    return this.request(url)
  }
}
